import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Truck, ArrowLeft, EnvelopeSimple } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2.5 mb-8 justify-center">
          <div className="p-2 rounded-md bg-blue-600 text-slate-950"><Truck size={24} weight="fill" /></div>
          <span className="font-heading font-black text-xl text-slate-900">FreightCommand</span>
        </div>
        {sent ? (
          <div className="text-center bg-white border border-slate-200 rounded-md p-8">
            <EnvelopeSimple size={40} weight="duotone" className="text-blue-600 mx-auto mb-4" />
            <h1 className="font-heading font-bold text-xl text-slate-900">Check your email</h1>
            <p className="text-sm text-slate-500 mt-2">
              If that email is registered, a reset link has been sent. The link expires in 1 hour.
            </p>
          </div>
        ) : (
          <>
            <h1 className="font-heading font-black text-2xl text-slate-900">Reset password</h1>
            <p className="text-sm text-slate-500 mt-2 mb-6">Enter your email and we'll send a reset link.</p>
            <form onSubmit={submit} className="space-y-4">
              <Input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="you@company.com" required
                className="bg-white border-slate-300 focus:border-blue-500 focus-visible:ring-blue-500 h-11" />
              {error && <p className="text-sm text-red-400">{error}</p>}
              <Button data-testid="forgot-submit" type="submit" disabled={loading}
                className="w-full h-11 bg-blue-600 text-white hover:bg-blue-700 font-semibold">
                {loading ? "Sending…" : "Send reset link"}
              </Button>
            </form>
          </>
        )}
        <div className="mt-6 text-center">
          <Link to="/login" className="text-sm text-slate-500 hover:text-blue-600 inline-flex items-center gap-1.5">
            <ArrowLeft size={14} /> Back to sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
